(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-backseat-v4-content"] && !Shopify.designMode) return;
  try {
    
  /* Matrikar Backseat V4 — vanilla JS IIFE (no Liquid) */
  (function () {
    var root = document.querySelector('[data-bsv4-section]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id') || '';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var currencyIso = root.getAttribute('data-currency-iso') || 'CAD';
    var variantId = parseInt(root.getAttribute('data-variant-id'), 10);
    var variantPriceCents = parseInt(root.getAttribute('data-variant-price-cents'), 10) || 0;

    /* Global qty state, max 9 (= 9 pockets / 9 sieges max raisonnable) */
    var qty = 1;
    var QTY_MIN = 1;
    var QTY_MAX = 9;
    var isAdding = false;

    function formatMoneyCents(cents) {
      var iso = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || currencyIso;
      if (window.Shopify && window.Shopify.formatMoney) {
        var fmt = window.Shopify.money_format || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function syncDisplays() {
      var displays = root.querySelectorAll('[data-bsv4-qty-display]');
      Array.prototype.forEach.call(displays, function (el) {
        el.textContent = qty;
      });
      var minusBtns = root.querySelectorAll('[data-bsv4-qty-minus]');
      var plusBtns = root.querySelectorAll('[data-bsv4-qty-plus]');
      Array.prototype.forEach.call(minusBtns, function (b) { b.disabled = qty <= QTY_MIN; });
      Array.prototype.forEach.call(plusBtns, function (b) { b.disabled = qty >= QTY_MAX; });
      var total = variantPriceCents * qty;
      var label = formatMoneyCents(total);
      var stickyPrices = root.querySelectorAll('[data-bsv4-sticky-price], [data-bsv4-sticky-mobile-price]');
      Array.prototype.forEach.call(stickyPrices, function (n) { n.textContent = label; });

      /* PATCH 45 — sync bidirectionnelle vers le stepper autonome */
      var standaloneInputs = document.querySelectorAll('[data-bsv4-qty-input]');
      Array.prototype.forEach.call(standaloneInputs, function (inp) {
        if (parseInt(inp.value, 10) !== qty) inp.value = qty;
      });
      var standaloneSteps = document.querySelectorAll('[data-bsv4-qty-standalone] [data-qty-step]');
      Array.prototype.forEach.call(standaloneSteps, function (b) {
        var dir = b.getAttribute('data-qty-step');
        if (dir === 'down') b.disabled = qty <= QTY_MIN;
        else if (dir === 'up') b.disabled = qty >= QTY_MAX;
      });
    }

    /* 1. Sticky nav trigger
       PATCH 43 (2026-05-30) — apparition rapide pour rendre le qty stepper
       accessible des le load. AVANT : 2000ms delay + scrollY > 400 -> l'utilisateur
       ne voyait aucun selecteur quantite pendant 2 secondes (le block Prestige
       quantity_selector etant disabled dans le template). APRES : 200ms delay
       (= juste eviter un flash au paint initial) + scrollY > 100 (= des le
       premier scroll). Le sticky desktop apparait au top, le sticky mobile en
       bottom avec qty +/- fonctionnels. */
    (function () {
      var snavTop = root.querySelector('[data-bsv4-snav-desktop]');
      var snavBot = root.querySelector('[data-bsv4-snav-mobile]');
      var shown = false;
      function show() {
        if (shown) return;
        shown = true;
        if (snavTop) snavTop.classList.add('is-visible');
        if (snavBot) snavBot.classList.add('is-visible');
      }
      setTimeout(show, 200);
      function onScroll() {
        if (window.scrollY > 100) {
          show();
          window.removeEventListener('scroll', onScroll);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    })();

    /* 2. Sticky desktop tabs + scroll-spy */
    (function () {
      if (!sectionId) return;
      var snavTop = root.querySelector('[data-bsv4-snav-desktop]');
      if (!snavTop) return;
      var tabs = snavTop.querySelectorAll('[data-bsv4-tab]');
      var targetMap = {
        overview: 'bsv4-overview-' + sectionId,
        pockets: 'bsv4-pockets-' + sectionId,
        protection: 'bsv4-protection-' + sectionId,
        compare: 'bsv4-compare-' + sectionId,
        reviews: 'bsv4-reviews-' + sectionId,
        faq: 'bsv4-faq-' + sectionId
      };
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          var t = document.getElementById(targetMap[tab.getAttribute('data-bsv4-tab')]);
          if (!t) return;
          var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });
      if (!('IntersectionObserver' in window)) return;
      var sections = Object.keys(targetMap)
        .map(function (k) { return { key: k, el: document.getElementById(targetMap[k]) }; })
        .filter(function (s) { return !!s.el; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            var matched = null;
            for (var i = 0; i < sections.length; i++) {
              if (sections[i].el.id === id) { matched = sections[i]; break; }
            }
            if (matched) {
              Array.prototype.forEach.call(tabs, function (t) {
                t.classList.toggle('bsv4-snav-desktop__tab--active', t.getAttribute('data-bsv4-tab') === matched.key);
              });
            }
          }
        });
      }, { rootMargin: '-50% 0px -50% 0px' });
      sections.forEach(function (s) { obs.observe(s.el); });
    })();

    /* 3. Quantity stepper (delegated, sync all displays) */
    root.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-bsv4-qty-minus]');
      if (minus) {
        e.preventDefault();
        if (qty > QTY_MIN) qty -= 1;
        syncDisplays();
        return;
      }
      var plus = e.target.closest('[data-bsv4-qty-plus]');
      if (plus) {
        e.preventDefault();
        if (qty < QTY_MAX) qty += 1;
        syncDisplays();
        return;
      }
    });

    /* 4. S2 9 Pockets explorer
       PATCH 42 (2026-05-30) : event delegation + lecture directe des
       data-attributes sur les <button> dots (cf. markup PATCH 42 plus haut).
       Plus de dataNodes separes, plus de matching par index -> 0 desync.
       Le listener est attache au container parent : robuste meme si Shopify
       re-render la section (les dots restent enfants du container). */
    (function () {
      var container = root.querySelector('[data-bsv4-pockets]');
      if (!container) return;
      var titleEl = container.querySelector('[data-bsv4-pocket-title]');
      var descEl = container.querySelector('[data-bsv4-pocket-desc]');
      if (!titleEl || !descEl) return;
      container.addEventListener('click', function (ev) {
        var dot = ev.target.closest('[data-bsv4-dot]');
        if (!dot || !container.contains(dot)) return;
        var allDots = container.querySelectorAll('[data-bsv4-dot]');
        Array.prototype.forEach.call(allDots, function (d) {
          d.classList.toggle('is-active', d === dot);
        });
        titleEl.textContent = dot.getAttribute('data-title') || '';
        descEl.textContent = dot.getAttribute('data-desc') || '';
      });
    })();

    /* 5. Add to Cart — direct fetch /cart/add.js with quantity (no main form quantity selector) */
    function addToCart(btn) {
      if (isAdding || !variantId) return;
      isAdding = true;
      var allCtas = root.querySelectorAll('[data-bsv4-add-to-cart]');
      Array.prototype.forEach.call(allCtas, function (b) {
        b.disabled = true; b.classList.add('is-loading');
      });
      var originalLabel = null;
      var labelEl = btn ? btn.querySelector('[data-bsv4-cta-label]') : null;
      if (labelEl) { originalLabel = labelEl.textContent; labelEl.textContent = 'Adding...'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          /* Cart drawer auto-opens via existing fetch interception (cart-drawer.liquid:858-873).
             Reset stepper to 1 post-success. */
          qty = QTY_MIN;
          syncDisplays();
        })
        .catch(function (err) {
          var msg = (err && err.description) || (err && err.message) || 'Could not add to cart';
          window.alert('Error: ' + msg);
        })
        .then(function () {
          isAdding = false;
          Array.prototype.forEach.call(allCtas, function (b) {
            b.disabled = false; b.classList.remove('is-loading');
          });
          if (labelEl && originalLabel !== null) labelEl.textContent = originalLabel;
        });
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bsv4-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn);
    });

    /* 7. PATCH 45 (2026-05-30) — Stepper quantite autonome
       Independant du composant Prestige <quantity-selector> (cassé). Vrai
       <input name="quantity">, event delegation niveau document, sync avec
       qty global de l'IIFE V4 -> tous les displays (sticky desktop, sticky
       mobile, S9 Final, ATC V4 fetch) restent coherents. */
    (function () {
      var standaloneInput = document.querySelector('[data-bsv4-qty-input]');

      /* a) Rattacher l'input au main form Prestige via attribut form=""
            -> ATC Prestige standard (s'il est utilise) recoit la qty. */
      var mainForm = document.querySelector('form[id^="product-form-main-"]');
      if (mainForm && mainForm.id && standaloneInput) {
        standaloneInput.setAttribute('form', mainForm.id);
      }

      /* b) Event delegation niveau DOCUMENT pour les boutons − / +
            -> ne depend pas de [data-bsv4-section] (qui pourrait etre null
            ou hors DOM dans certains scenarios). Robuste. */
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty-step]');
        if (!btn) return;
        var wrap = btn.closest('[data-qty]');
        if (!wrap) return;
        var inp = wrap.querySelector('input[name="quantity"]');
        if (!inp) return;
        e.preventDefault();
        var v = parseInt(inp.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        v += (btn.getAttribute('data-qty-step') === 'up' ? 1 : -1);
        if (v < QTY_MIN) v = QTY_MIN;
        if (v > QTY_MAX) v = QTY_MAX;
        inp.value = v;
        qty = v;
        syncDisplays();
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });

      /* c) Frappe clavier dans l'input (utilisateur tape "3", "5", etc.) */
      if (standaloneInput) {
        var onUserInput = function () {
          var v = parseInt(standaloneInput.value, 10);
          if (isNaN(v) || v < QTY_MIN) v = QTY_MIN;
          if (v > QTY_MAX) v = QTY_MAX;
          qty = v;
          syncDisplays();
        };
        standaloneInput.addEventListener('input', onUserInput);
        standaloneInput.addEventListener('change', function () {
          onUserInput();
          /* Reflect clamped value back into the input */
          standaloneInput.value = qty;
        });
      }
    })();

    /* 6. Init */
    syncDisplays();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-petshield-v4-content"] && !Shopify.designMode) return;
  try {
    
  /* Matrikar PetShield V4 — vanilla JS IIFE (no Liquid) */
  (function () {
    var root = document.querySelector('[data-psv4-section]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id') || '';
    var productId = root.getAttribute('data-product-id') || '';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var currencyIso = root.getAttribute('data-currency-iso') || 'CAD';
    var variantCache = null;

    function findMainForm() {
      if (productId) {
        var f = document.querySelector('form[id^="product-form-main-' + productId + '-"][action*="/cart/add"]');
        if (f) return f;
      }
      return document.querySelector('product-form form[action*="/cart/add"]')
          || document.querySelector('form[id^="product-form-main-"][action*="/cart/add"]');
    }
    function submitMainForm() {
      var form = findMainForm();
      if (!form) return false;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
      return true;
    }
    function scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    function formatMoneyCents(cents) {
      var iso = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || currencyIso;
      if (window.Shopify && window.Shopify.formatMoney) {
        var fmt = window.Shopify.money_format || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
      return '$' + (cents / 100).toFixed(2);
    }
    function fetchVariants(cb) {
      if (variantCache) { cb(variantCache); return; }
      if (!productHandle) { cb(null); return; }
      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (d) { variantCache = d.variants || []; cb(variantCache); })
        .catch(function () { cb(null); });
    }

    /* 1. Sticky nav trigger (2s OR scrollY > 400) */
    (function () {
      var snavTop = root.querySelector('[data-psv4-snav-desktop]');
      var snavBot = root.querySelector('[data-psv4-snav-mobile]');
      var shown = false;
      function show() {
        if (shown) return;
        shown = true;
        if (snavTop) snavTop.classList.add('is-visible');
        if (snavBot) snavBot.classList.add('is-visible');
      }
      setTimeout(show, 2000);
      function onScroll() {
        if (window.scrollY > 400) {
          show();
          window.removeEventListener('scroll', onScroll);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    })();

    /* 2. Sticky desktop tabs + scroll-spy */
    (function () {
      if (!sectionId) return;
      var snavTop = root.querySelector('[data-psv4-snav-desktop]');
      if (!snavTop) return;
      var tabs = snavTop.querySelectorAll('[data-psv4-tab]');
      var targetMap = {
        overview: 'psv4-overview-' + sectionId,
        protection: 'psv4-protection-' + sectionId,
        safety: 'psv4-safety-' + sectionId,
        modes: 'psv4-modes-' + sectionId,
        compare: 'psv4-compare-' + sectionId,
        faq: 'psv4-faq-' + sectionId
      };
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          var t = document.getElementById(targetMap[tab.getAttribute('data-psv4-tab')]);
          if (!t) return;
          var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });
      if (!('IntersectionObserver' in window)) return;
      var sections = Object.keys(targetMap)
        .map(function (k) { return { key: k, el: document.getElementById(targetMap[k]) }; })
        .filter(function (s) { return !!s.el; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            var matched = null;
            for (var i = 0; i < sections.length; i++) {
              if (sections[i].el.id === id) { matched = sections[i]; break; }
            }
            if (matched) {
              Array.prototype.forEach.call(tabs, function (t) {
                t.classList.toggle('psv4-snav-desktop__tab--active', t.getAttribute('data-psv4-tab') === matched.key);
              });
            }
          }
        });
      }, { rootMargin: '-50% 0px -50% 0px' });
      sections.forEach(function (s) { obs.observe(s.el); });
    })();

    /* 3. S5 3-in-1 modes toggle */
    (function () {
      var container = root.querySelector('[data-psv4-modes]');
      if (!container) return;
      var tabs = container.querySelectorAll('[data-psv4-mode-tab]');
      var panels = container.querySelectorAll('[data-psv4-mode-panel]');
      if (!tabs.length || !panels.length) return;
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-psv4-mode-tab');
          Array.prototype.forEach.call(tabs, function (t) {
            var active = t.getAttribute('data-psv4-mode-tab') === idx;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          Array.prototype.forEach.call(panels, function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-psv4-mode-panel') === idx);
          });
        });
      });
    })();

    /* 4. Sticky ATC + Final CTA -> submit main form (fallback scroll top) */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-psv4-sticky-atc]');
      if (!btn) return;
      e.preventDefault();
      if (!submitMainForm()) scrollToTop();
    });

    /* 5. Sticky price sync (1 variant — mais on couvre l'edge case ou variant change) */
    (function () {
      var stickyPrices = root.querySelectorAll('[data-psv4-sticky-price], [data-psv4-sticky-mobile-price]');
      if (!stickyPrices.length) return;
      function getVariantIdFromForm() {
        var form = findMainForm();
        if (!form) return null;
        var input = form.querySelector('input[name="id"]');
        return input ? input.value : null;
      }
      function updatePrice() {
        var vid = getVariantIdFromForm();
        if (!vid) return;
        fetchVariants(function (vs) {
          if (!vs) return;
          var v = null;
          for (var i = 0; i < vs.length; i++) {
            if (String(vs[i].id) === String(vid)) { v = vs[i]; break; }
          }
          if (!v || typeof v.price !== 'number') return;
          var label = formatMoneyCents(v.price);
          Array.prototype.forEach.call(stickyPrices, function (n) { n.textContent = label; });
        });
      }
      document.addEventListener('variant:change', function () { setTimeout(updatePrice, 80); });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-v4-content"] && !Shopify.designMode) return;
  try {
    
  /* Matrikar PDP V4 — vanilla JS (IIFE, no Liquid evaluated here). */
  (function () {
    var root = document.querySelector('[data-mkv4-section]');
    if (!root) return;

    var sectionId = root.getAttribute('data-section-id') || '';
    var productId = root.getAttribute('data-product-id') || '';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var variantCache = null;

    function readVehicle() {
      try {
        var raw = localStorage.getItem('matrikar_vehicle');
        if (!raw) return null;
        var v = JSON.parse(raw);
        if (v && v.make && v.year && v.model) return v;
        return null;
      } catch (e) {
        return null;
      }
    }

    function vehicleHtml(v) {
      if (!v) return '';
      var parts = [];
      if (v.year) parts.push(v.year);
      if (v.make) parts.push(v.make);
      if (v.model) parts.push(v.model);
      return '<strong>' + parts.join(' ') + '.</strong>';
    }

    function findMainForm() {
      if (productId) {
        var f = document.querySelector('form[id^="product-form-main-' + productId + '-"][action*="/cart/add"]');
        if (f) return f;
      }
      return document.querySelector('product-form form[action*="/cart/add"]')
          || document.querySelector('form[id^="product-form-main-"][action*="/cart/add"]');
    }

    function formatMoneyCents(cents) {
      var iso = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || root.getAttribute('data-currency-iso') || 'CAD';
      if (window.Shopify && window.Shopify.formatMoney) {
        var fmt = window.Shopify.money_format || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function fetchVariants(cb) {
      if (variantCache) { cb(variantCache); return; }
      if (!productHandle) { cb(null); return; }
      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          variantCache = d.variants || [];
          cb(variantCache);
        })
        .catch(function () { cb(null); });
    }

    /* 1. Stat counter (scroll-triggered) */
    (function () {
      var counters = root.querySelectorAll('[data-mkv4-counter]');
      if (!counters.length || !('IntersectionObserver' in window)) return;
      function animate(el) {
        var target = parseFloat(el.getAttribute('data-mkv4-counter')) || 0;
        var suffix = el.getAttribute('data-mkv4-counter-suffix') || '';
        var duration = 1400;
        var start = null;
        function step(now) {
          if (!start) start = now;
          var t = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          var raw = target * eased;
          var value;
          if (target >= 1000) {
            value = Math.floor(raw).toLocaleString('en-US');
          } else if (target % 1 !== 0) {
            value = raw.toFixed(1);
          } else {
            value = Math.floor(raw).toString();
          }
          el.textContent = value + suffix;
          if (t < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (c) { obs.observe(c); });
    })();

    /* 2. Sticky nav trigger (2s OR scrollY > 400) */
    (function () {
      var snavTop = root.querySelector('[data-mkv4-snav-desktop]');
      var snavBot = root.querySelector('[data-mkv4-snav-mobile]');
      var shown = false;
      function show() {
        if (shown) return;
        shown = true;
        if (snavTop) snavTop.classList.add('is-visible');
        if (snavBot) snavBot.classList.add('is-visible');
      }
      setTimeout(show, 2000);
      function onScroll() {
        if (window.scrollY > 400) {
          show();
          window.removeEventListener('scroll', onScroll);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    })();

    /* 3. Sticky desktop tabs + scroll-spy */
    (function () {
      if (!sectionId) return;
      var snavTop = root.querySelector('[data-mkv4-snav-desktop]');
      if (!snavTop) return;
      var tabs = snavTop.querySelectorAll('[data-mkv4-tab]');
      var targetMap = {
        overview: 'mkv4-overview-' + sectionId,
        engineering: 'mkv4-engineering-' + sectionId,
        compare: 'mkv4-compare-' + sectionId,
        reviews: 'mkv4-reviews-' + sectionId,
        faq: 'mkv4-faq-' + sectionId
      };
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          var t = document.getElementById(targetMap[tab.getAttribute('data-mkv4-tab')]);
          if (!t) return;
          var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });
      if (!('IntersectionObserver' in window)) return;
      var sections = Object.keys(targetMap)
        .map(function (k) { return { key: k, el: document.getElementById(targetMap[k]) }; })
        .filter(function (s) { return !!s.el; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            var matched = null;
            for (var i = 0; i < sections.length; i++) {
              if (sections[i].el.id === id) { matched = sections[i]; break; }
            }
            if (matched) {
              Array.prototype.forEach.call(tabs, function (t) {
                t.classList.toggle('mkv4-snav-desktop__tab--active', t.getAttribute('data-mkv4-tab') === matched.key);
              });
            }
          }
        });
      }, { rootMargin: '-50% 0px -50% 0px' });
      sections.forEach(function (s) { obs.observe(s.el); });
    })();

    /* 4. Smooth scroll [data-mkv4-scroll-to] */
    (function () {
      var aliases = {
        'vehicle-fit': '#mkvfit-wrap',
        'overview': '#mkv4-overview-' + sectionId
      };
      root.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-mkv4-scroll-to]');
        if (!trigger) return;
        var key = trigger.getAttribute('data-mkv4-scroll-to');
        var selector = aliases[key] || ('#' + key);
        var node = document.querySelector(selector);
        if (!node) return;
        e.preventDefault();
        var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    })();

    /* 4b. Find My Fit conditionnel [data-mkv4-cta-fit] (brief 24 M3) :
       - vehicle saved (localStorage.matrikar_vehicle complet) → submit main form (ATC direct)
       - sinon → scroll vers le selecteur vehicle (fallback) */
    (function () {
      function readVehicleLocal() {
        try {
          var raw = localStorage.getItem('matrikar_vehicle');
          if (!raw) return null;
          var v = JSON.parse(raw);
          if (v && v.make && v.year && v.model) return v;
          return null;
        } catch (e) { return null; }
      }
      function findMainFormLocal() {
        if (productId) {
          var f = document.querySelector('form[id^="product-form-main-' + productId + '-"][action*="/cart/add"]');
          if (f) return f;
        }
        return document.querySelector('product-form form[action*="/cart/add"]')
            || document.querySelector('form[id^="product-form-main-"][action*="/cart/add"]');
      }
      root.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-mkv4-cta-fit]');
        if (!trigger) return;
        e.preventDefault();
        var v = readVehicleLocal();
        if (v) {
          var form = findMainFormLocal();
          if (form) {
            if (typeof form.requestSubmit === 'function') form.requestSubmit();
            else form.submit();
            return;
          }
        }
        var node = document.querySelector('#mkvfit-wrap');
        if (!node) return;
        var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    })();

    /* 5. Vehicle-conditional content */
    (function () {
      var variantsScript = root.querySelector('[data-mkv4-anchor-variants]');
      var variants = [];
      if (variantsScript) {
        try { variants = JSON.parse(variantsScript.textContent) || []; } catch (e) { variants = []; }
      }
      var defaultVariant = variants[0] || null;

      function pickVariant(make) {
        if (!make) return defaultVariant;
        var lower = String(make).toLowerCase();
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!v || !v.make_keywords) continue;
          var kws = String(v.make_keywords).split(',');
          for (var j = 0; j < kws.length; j++) {
            var kw = kws[j].trim();
            if (kw && lower.indexOf(kw) !== -1) return v;
          }
        }
        return defaultVariant;
      }

      var anchorQuoteEl = root.querySelector('[data-mkv4-anchor-quote]');
      var anchorNameEl = root.querySelector('[data-mkv4-anchor-name]');
      var anchorInitialsEl = root.querySelector('[data-mkv4-anchor-initials]');
      var anchorVehicleEl = root.querySelector('[data-mkv4-anchor-vehicle]');
      var anchorImageEl = root.querySelector('[data-mkv4-anchor-image]');
      var reviewsConditional = root.querySelector('[data-mkv4-reviews-conditional]');
      var finalHeadline = root.querySelector('[data-mkv4-final-headline]');
      var finalSub = root.querySelector('[data-mkv4-final-sub]');
      var finalCta = root.querySelector('[data-mkv4-final-cta]');
      var stickyAtcs = root.querySelectorAll('[data-mkv4-sticky-atc]');

      function applyAnchor(v) {
        if (!v) return;
        if (anchorQuoteEl) anchorQuoteEl.innerHTML = v.quote || '';
        if (anchorNameEl) anchorNameEl.textContent = v.author_name || '';
        if (anchorInitialsEl) anchorInitialsEl.textContent = v.author_initials || '';
        if (anchorVehicleEl) anchorVehicleEl.textContent = v.author_vehicle || '';
        if (anchorImageEl && v.image_url) {
          anchorImageEl.style.backgroundImage = "url('" + v.image_url + "')";
        }
      }

      function applyReviewsHeader(vehicle) {
        if (!reviewsConditional) return;
        if (!vehicle || !vehicle.make) {
          reviewsConditional.classList.remove('is-visible');
          reviewsConditional.textContent = '';
          return;
        }
        var template = reviewsConditional.getAttribute('data-mkv4-template') || 'Reviews from {make} owners.';
        reviewsConditional.textContent = template.replace('{make}', vehicle.make);
        reviewsConditional.classList.add('is-visible');
      }

      function applyFinal(vehicle) {
        var saved = !!vehicle;
        if (finalHeadline) {
          var defH = finalHeadline.getAttribute('data-mkv4-default-html') || '';
          var savH = finalHeadline.getAttribute('data-mkv4-saved-template') || defH;
          finalHeadline.innerHTML = saved ? savH.replace('{vehicle}', vehicleHtml(vehicle)) : defH;
        }
        if (finalSub) {
          var defS = finalSub.getAttribute('data-mkv4-default-html') || '';
          var savS = finalSub.getAttribute('data-mkv4-saved-template') || defS;
          finalSub.innerHTML = saved ? savS.replace('{vehicle}', vehicleHtml(vehicle)) : defS;
        }
        if (finalCta) {
          var defL = finalCta.getAttribute('data-mkv4-default-label') || '';
          var savL = finalCta.getAttribute('data-mkv4-saved-label') || defL;
          finalCta.textContent = saved ? savL : defL;
          finalCta.setAttribute('data-mkv4-action', saved ? 'submit-main-form' : 'scroll-to-vehicle-fit');
        }
      }

      function applyStickyAtc(vehicle) {
        var saved = !!vehicle;
        Array.prototype.forEach.call(stickyAtcs, function (btn) {
          var defL = btn.getAttribute('data-mkv4-default-label') || '';
          var disL = btn.getAttribute('data-mkv4-disabled-label') || defL;
          var labelEl = btn.querySelector('[data-mkv4-sticky-atc-label]');
          if (saved) {
            btn.classList.remove('is-disabled');
            btn.disabled = false;
            if (labelEl) labelEl.textContent = defL;
            else btn.textContent = defL;
          } else {
            btn.classList.add('is-disabled');
            btn.disabled = true;
            if (labelEl) labelEl.textContent = disL;
            else btn.textContent = disL;
          }
        });
      }

      function syncAll() {
        var v = readVehicle();
        var anchor = pickVariant(v && v.make);
        applyAnchor(anchor || defaultVariant);
        applyReviewsHeader(v);
        applyFinal(v);
        applyStickyAtc(v);
      }

      syncAll();
      document.addEventListener('matrikar:vehicleSelected', syncAll);
      window.addEventListener('storage', function (e) {
        if (e.key === 'matrikar_vehicle') syncAll();
      });
    })();

    /* 6. Sticky ATC + Final CTA actions */
    (function () {
      function submitMainForm() {
        var form = findMainForm();
        if (!form) return false;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
        return true;
      }
      function scrollToVehicleFit() {
        var node = document.querySelector('#mkvfit-wrap');
        if (!node) return;
        var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
      root.addEventListener('click', function (e) {
        var stickyBtn = e.target.closest('[data-mkv4-sticky-atc]');
        if (stickyBtn) {
          if (stickyBtn.classList.contains('is-disabled') || stickyBtn.disabled) {
            scrollToVehicleFit();
            return;
          }
          if (!submitMainForm()) scrollToVehicleFit();
          return;
        }
        var finalBtn = e.target.closest('[data-mkv4-final-cta]');
        if (finalBtn) {
          var action = finalBtn.getAttribute('data-mkv4-action') || 'scroll-to-vehicle-fit';
          if (action === 'submit-main-form') {
            if (!submitMainForm()) scrollToVehicleFit();
          } else {
            scrollToVehicleFit();
          }
        }
      });
    })();

    /* 7. Sticky price sync */
    (function () {
      var stickyPrices = root.querySelectorAll('[data-mkv4-sticky-price], [data-mkv4-sticky-mobile-price]');
      if (!stickyPrices.length) return;

      function getVariantIdFromForm() {
        var form = findMainForm();
        if (!form) return null;
        var input = form.querySelector('input[name="id"]');
        return input ? input.value : null;
      }
      function updatePrice() {
        var vid = getVariantIdFromForm();
        if (!vid) return;
        fetchVariants(function (vs) {
          if (!vs) return;
          var v = null;
          for (var i = 0; i < vs.length; i++) {
            if (String(vs[i].id) === String(vid)) { v = vs[i]; break; }
          }
          if (!v || typeof v.price !== 'number') return;
          var label = formatMoneyCents(v.price);
          Array.prototype.forEach.call(stickyPrices, function (n) { n.textContent = label; });
        });
      }
      function bind() {
        var form = findMainForm();
        if (form) {
          var sel = form.querySelector('select[name="id"]');
          if (sel) sel.addEventListener('change', function () { setTimeout(updatePrice, 80); });
        }
        var radios = document.querySelectorAll('input[type="radio"][data-option-position], .variant-set-card input[type="radio"]');
        Array.prototype.forEach.call(radios, function (r) {
          r.addEventListener('change', function () { setTimeout(updatePrice, 120); });
        });
        document.addEventListener('variant:change', function () { setTimeout(updatePrice, 80); });
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bind);
      } else {
        bind();
      }
    })();

    /* =====================================================================
       PATCH 34 (2026-05-30) — Badge "Proudly Canadian" : injection JS abandonnee
       ---------------------------------------------------------------------
       Le PATCH 32 tentait d'injecter le badge via JS dans
       .product-gallery__media.is-initial mais l'injection echouait :
       <product-gallery> (custom element Prestige) re-rendait le DOM async
       et perdait le badge, OU le timing DOMContentLoaded etait trop tot.
       PATCH 34 remplace par un rendu server-side Liquid directement dans
       snippets/product-gallery.liquid (replique le mecanisme fiable
       d'on-sale-badge dans product-badges.liquid). Cf. rapport 34.
       La CSS .mkv4-gallery__badge dans le {% stylesheet %} reste utile :
       elle stylise le HTML rendu cote serveur par le snippet.
       ===================================================================== */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-seat-covers-v4-content"] && !Shopify.designMode) return;
  try {
    
  /* Matrikar Seat Covers V4 — vanilla JS IIFE (no Liquid here) */
  (function () {
    var root = document.querySelector('[data-skv4-section]');
    if (!root) return;

    var sectionId = root.getAttribute('data-section-id') || '';
    var productId = root.getAttribute('data-product-id') || '';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var currencyIso = root.getAttribute('data-currency-iso') || 'CAD';
    var variantCache = null;

    function readVehicle() {
      try {
        var raw = localStorage.getItem('matrikar_vehicle');
        if (!raw) return null;
        var v = JSON.parse(raw);
        if (v && v.make && v.year && v.model) return v;
        return null;
      } catch (e) { return null; }
    }

    function vehicleHtml(v) {
      if (!v) return '';
      var parts = [];
      if (v.year) parts.push(v.year);
      if (v.make) parts.push(v.make);
      if (v.model) parts.push(v.model);
      return '<strong>' + parts.join(' ') + '.</strong>';
    }

    function findMainForm() {
      if (productId) {
        var f = document.querySelector('form[id^="product-form-main-' + productId + '-"][action*="/cart/add"]');
        if (f) return f;
      }
      return document.querySelector('product-form form[action*="/cart/add"]')
          || document.querySelector('form[id^="product-form-main-"][action*="/cart/add"]');
    }

    function formatMoneyCents(cents) {
      var iso = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || currencyIso;
      if (window.Shopify && window.Shopify.formatMoney) {
        var fmt = window.Shopify.money_format || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function fetchVariants(cb) {
      if (variantCache) { cb(variantCache); return; }
      if (!productHandle) { cb(null); return; }
      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (d) { variantCache = d.variants || []; cb(variantCache); })
        .catch(function () { cb(null); });
    }

    /* 1. Stat counter (scroll-triggered) */
    (function () {
      var counters = root.querySelectorAll('[data-skv4-counter]');
      if (!counters.length || !('IntersectionObserver' in window)) return;
      function animate(el) {
        var target = parseFloat(el.getAttribute('data-skv4-counter')) || 0;
        var suffix = el.getAttribute('data-skv4-counter-suffix') || '';
        var duration = 1400;
        var start = null;
        function step(now) {
          if (!start) start = now;
          var t = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          var raw = target * eased;
          var value;
          if (target >= 1000) value = Math.floor(raw).toLocaleString('en-US');
          else if (target % 1 !== 0) value = raw.toFixed(1);
          else value = Math.floor(raw).toString();
          el.textContent = value + suffix;
          if (t < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { animate(e.target); obs.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (c) { obs.observe(c); });
    })();

    /* 2. Before/After slider */
    (function () {
      var ba = root.querySelector('[data-skv4-ba]');
      if (!ba) return;
      var range = ba.querySelector('[data-skv4-ba-range]');
      var after = ba.querySelector('[data-skv4-ba-after]');
      var div = ba.querySelector('[data-skv4-ba-div]');
      var handle = ba.querySelector('[data-skv4-ba-handle]');
      if (!range || !after || !div || !handle) return;
      function update(v) {
        after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
        div.style.left = v + '%';
        handle.style.left = v + '%';
      }
      range.addEventListener('input', function (e) { update(e.target.value); });
      update(50);
    })();

    /* 3. Airbag breakaway demo — scroll-triggered */
    (function () {
      var diagram = root.querySelector('[data-skv4-safe-diagram]');
      if (!diagram || !('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            setTimeout(function () { diagram.classList.add('is-deployed'); }, 500);
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.5 });
      obs.observe(diagram);
    })();

    /* 4. Sticky nav trigger (2s OR scrollY > 400) */
    (function () {
      var snavTop = root.querySelector('[data-skv4-snav-desktop]');
      var snavBot = root.querySelector('[data-skv4-snav-mobile]');
      var shown = false;
      function show() {
        if (shown) return;
        shown = true;
        if (snavTop) snavTop.classList.add('is-visible');
        if (snavBot) snavBot.classList.add('is-visible');
      }
      setTimeout(show, 2000);
      function onScroll() {
        if (window.scrollY > 400) {
          show();
          window.removeEventListener('scroll', onScroll);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    })();

    /* 5. Sticky desktop tabs + scroll-spy */
    (function () {
      if (!sectionId) return;
      var snavTop = root.querySelector('[data-skv4-snav-desktop]');
      if (!snavTop) return;
      var tabs = snavTop.querySelectorAll('[data-skv4-tab]');
      var targetMap = {
        overview: 'skv4-overview-' + sectionId,
        safety: 'skv4-safety-' + sectionId,
        material: 'skv4-material-' + sectionId,
        compare: 'skv4-compare-' + sectionId,
        reviews: 'skv4-reviews-' + sectionId,
        faq: 'skv4-faq-' + sectionId
      };
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          var t = document.getElementById(targetMap[tab.getAttribute('data-skv4-tab')]);
          if (!t) return;
          var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });
      if (!('IntersectionObserver' in window)) return;
      var sections = Object.keys(targetMap)
        .map(function (k) { return { key: k, el: document.getElementById(targetMap[k]) }; })
        .filter(function (s) { return !!s.el; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            var matched = null;
            for (var i = 0; i < sections.length; i++) {
              if (sections[i].el.id === id) { matched = sections[i]; break; }
            }
            if (matched) {
              Array.prototype.forEach.call(tabs, function (t) {
                t.classList.toggle('skv4-snav-desktop__tab--active', t.getAttribute('data-skv4-tab') === matched.key);
              });
            }
          }
        });
      }, { rootMargin: '-50% 0px -50% 0px' });
      sections.forEach(function (s) { obs.observe(s.el); });
    })();

    /* 6. Vehicle-conditional Final CTA (headline / sub / cta) */
    (function () {
      var headlineEl = root.querySelector('[data-skv4-final-headline]');
      var subEl = root.querySelector('[data-skv4-final-sub]');
      var ctaEl = root.querySelector('[data-skv4-final-cta]');
      var stickyAtcs = root.querySelectorAll('[data-skv4-sticky-atc]');

      function applyFinal(v) {
        var saved = !!v;
        if (headlineEl) {
          var defH = headlineEl.getAttribute('data-skv4-default-html') || '';
          var savH = headlineEl.getAttribute('data-skv4-saved-template') || defH;
          headlineEl.innerHTML = saved ? savH.replace(/\{vehicle\}|&lcub;vehicle&rcub;/g, vehicleHtml(v)) : defH;
        }
        if (subEl) {
          var defS = subEl.getAttribute('data-skv4-default-html') || '';
          var savS = subEl.getAttribute('data-skv4-saved-template') || defS;
          subEl.innerHTML = saved ? savS.replace(/\{vehicle\}|&lcub;vehicle&rcub;/g, vehicleHtml(v)) : defS;
        }
        if (ctaEl) {
          var defL = ctaEl.getAttribute('data-skv4-default-label') || '';
          var savL = ctaEl.getAttribute('data-skv4-saved-label') || defL;
          ctaEl.textContent = saved ? savL : defL;
          ctaEl.setAttribute('data-skv4-action', saved ? 'submit-main-form' : 'scroll-to-vehicle-fit');
        }
      }

      function applyStickyAtc(v) {
        var saved = !!v;
        Array.prototype.forEach.call(stickyAtcs, function (btn) {
          var defL = btn.getAttribute('data-skv4-default-label') || '';
          var disL = btn.getAttribute('data-skv4-disabled-label') || defL;
          var labelEl = btn.querySelector('[data-skv4-sticky-atc-label]');
          if (saved) {
            btn.classList.remove('is-disabled');
            btn.disabled = false;
            if (labelEl) labelEl.textContent = defL;
            else btn.textContent = defL;
          } else {
            btn.classList.add('is-disabled');
            btn.disabled = true;
            if (labelEl) labelEl.textContent = disL;
            else btn.textContent = disL;
          }
        });
      }

      function syncAll() {
        var v = readVehicle();
        applyFinal(v);
        applyStickyAtc(v);
      }

      syncAll();
      document.addEventListener('matrikar:vehicleSelected', syncAll);
      window.addEventListener('storage', function (e) {
        if (e.key === 'matrikar_vehicle') syncAll();
      });
    })();

    /* 7. Click handlers : Sticky ATC + Final CTA + Find My Fit conditional */
    (function () {
      function submitMainForm() {
        var form = findMainForm();
        if (!form) return false;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
        return true;
      }
      function scrollToVehicleFit() {
        var node = document.querySelector('#mkvfit-wrap');
        if (!node) return;
        var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }

      root.addEventListener('click', function (e) {
        var stickyBtn = e.target.closest('[data-skv4-sticky-atc]');
        if (stickyBtn) {
          if (stickyBtn.classList.contains('is-disabled') || stickyBtn.disabled) {
            scrollToVehicleFit();
            return;
          }
          if (!submitMainForm()) scrollToVehicleFit();
          return;
        }
        var finalBtn = e.target.closest('[data-skv4-final-cta]');
        if (finalBtn) {
          var action = finalBtn.getAttribute('data-skv4-action') || 'scroll-to-vehicle-fit';
          if (action === 'submit-main-form') {
            if (!submitMainForm()) scrollToVehicleFit();
          } else {
            scrollToVehicleFit();
          }
          return;
        }
        var fitBtn = e.target.closest('[data-skv4-cta-fit]');
        if (fitBtn) {
          e.preventDefault();
          var v = readVehicle();
          if (v) {
            if (!submitMainForm()) scrollToVehicleFit();
          } else {
            scrollToVehicleFit();
          }
        }
      });
    })();

    /* 8. Sticky price sync (variant change) */
    (function () {
      var stickyPrices = root.querySelectorAll('[data-skv4-sticky-price], [data-skv4-sticky-mobile-price]');
      if (!stickyPrices.length) return;
      function getVariantIdFromForm() {
        var form = findMainForm();
        if (!form) return null;
        var input = form.querySelector('input[name="id"]');
        return input ? input.value : null;
      }
      function updatePrice() {
        var vid = getVariantIdFromForm();
        if (!vid) return;
        fetchVariants(function (vs) {
          if (!vs) return;
          var v = null;
          for (var i = 0; i < vs.length; i++) {
            if (String(vs[i].id) === String(vid)) { v = vs[i]; break; }
          }
          if (!v || typeof v.price !== 'number') return;
          var label = formatMoneyCents(v.price);
          Array.prototype.forEach.call(stickyPrices, function (n) { n.textContent = label; });
        });
      }
      function bind() {
        var form = findMainForm();
        if (form) {
          var sel = form.querySelector('select[name="id"]');
          if (sel) sel.addEventListener('change', function () { setTimeout(updatePrice, 80); });
        }
        var radios = document.querySelectorAll('input[type="radio"][data-option-position], .variant-set-card input[type="radio"]');
        Array.prototype.forEach.call(radios, function (r) {
          r.addEventListener('change', function () { setTimeout(updatePrice, 120); });
        });
        document.addEventListener('variant:change', function () { setTimeout(updatePrice, 80); });
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bind);
      } else {
        bind();
      }
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-trunk-mats-v4-content"] && !Shopify.designMode) return;
  try {
    
  /* Matrikar Trunk Mats V4 — vanilla JS IIFE (no Liquid here) */
  (function () {
    var root = document.querySelector('[data-tmv4-section]');
    if (!root) return;

    var sectionId = root.getAttribute('data-section-id') || '';
    var productId = root.getAttribute('data-product-id') || '';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var currencyIso = root.getAttribute('data-currency-iso') || 'CAD';
    var variantCache = null;

    function readVehicle() {
      try {
        var raw = localStorage.getItem('matrikar_vehicle');
        if (!raw) return null;
        var v = JSON.parse(raw);
        if (v && v.make && v.year && v.model) return v;
        return null;
      } catch (e) { return null; }
    }

    function vehicleHtml(v) {
      if (!v) return '';
      var parts = [];
      if (v.year) parts.push(v.year);
      if (v.make) parts.push(v.make);
      if (v.model) parts.push(v.model);
      return '<strong>' + parts.join(' ') + '.</strong>';
    }

    function findMainForm() {
      if (productId) {
        var f = document.querySelector('form[id^="product-form-main-' + productId + '-"][action*="/cart/add"]');
        if (f) return f;
      }
      return document.querySelector('product-form form[action*="/cart/add"]')
          || document.querySelector('form[id^="product-form-main-"][action*="/cart/add"]');
    }

    function formatMoneyCents(cents) {
      var iso = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || currencyIso;
      if (window.Shopify && window.Shopify.formatMoney) {
        var fmt = window.Shopify.money_format || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function fetchVariants(cb) {
      if (variantCache) { cb(variantCache); return; }
      if (!productHandle) { cb(null); return; }
      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (d) { variantCache = d.variants || []; cb(variantCache); })
        .catch(function () { cb(null); });
    }

    /* 1. Stat counter (scroll-triggered) */
    (function () {
      var counters = root.querySelectorAll('[data-tmv4-counter]');
      if (!counters.length || !('IntersectionObserver' in window)) return;
      function animate(el) {
        var target = parseFloat(el.getAttribute('data-tmv4-counter')) || 0;
        var suffix = el.getAttribute('data-tmv4-counter-suffix') || '';
        var duration = 1400;
        var start = null;
        function step(now) {
          if (!start) start = now;
          var t = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          var raw = target * eased;
          var value;
          if (target >= 1000) value = Math.floor(raw).toLocaleString('en-US');
          else if (target % 1 !== 0) value = raw.toFixed(1);
          else value = Math.floor(raw).toString();
          el.textContent = value + suffix;
          if (t < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { animate(e.target); obs.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (c) { obs.observe(c); });
    })();

    /* 2. Before/After slider */
    (function () {
      var ba = root.querySelector('[data-tmv4-ba]');
      if (!ba) return;
      var range = ba.querySelector('[data-tmv4-ba-range]');
      var after = ba.querySelector('[data-tmv4-ba-after]');
      var div = ba.querySelector('[data-tmv4-ba-div]');
      var handle = ba.querySelector('[data-tmv4-ba-handle]');
      if (!range || !after || !div || !handle) return;
      function update(v) {
        after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
        div.style.left = v + '%';
        handle.style.left = v + '%';
      }
      range.addEventListener('input', function (e) { update(e.target.value); });
      update(50);
    })();

    /* 3. Waterproof containment demo — scroll-triggered */
    (function () {
      var diagram = root.querySelector('[data-tmv4-water-diagram]');
      if (!diagram || !('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            setTimeout(function () { diagram.classList.add('is-filled'); }, 400);
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.5 });
      obs.observe(diagram);
    })();

    /* 4. Sticky nav trigger (2s OR scrollY > 400) */
    (function () {
      var snavTop = root.querySelector('[data-tmv4-snav-desktop]');
      var snavBot = root.querySelector('[data-tmv4-snav-mobile]');
      var shown = false;
      function show() {
        if (shown) return;
        shown = true;
        if (snavTop) snavTop.classList.add('is-visible');
        if (snavBot) snavBot.classList.add('is-visible');
      }
      setTimeout(show, 2000);
      function onScroll() {
        if (window.scrollY > 400) {
          show();
          window.removeEventListener('scroll', onScroll);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    })();

    /* 5. Sticky desktop tabs + scroll-spy */
    (function () {
      if (!sectionId) return;
      var snavTop = root.querySelector('[data-tmv4-snav-desktop]');
      if (!snavTop) return;
      var tabs = snavTop.querySelectorAll('[data-tmv4-tab]');
      var targetMap = {
        overview: 'tmv4-overview-' + sectionId,
        waterproof: 'tmv4-waterproof-' + sectionId,
        material: 'tmv4-material-' + sectionId,
        compare: 'tmv4-compare-' + sectionId,
        reviews: 'tmv4-reviews-' + sectionId,
        faq: 'tmv4-faq-' + sectionId
      };
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          var t = document.getElementById(targetMap[tab.getAttribute('data-tmv4-tab')]);
          if (!t) return;
          var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });
      if (!('IntersectionObserver' in window)) return;
      var sections = Object.keys(targetMap)
        .map(function (k) { return { key: k, el: document.getElementById(targetMap[k]) }; })
        .filter(function (s) { return !!s.el; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            var matched = null;
            for (var i = 0; i < sections.length; i++) {
              if (sections[i].el.id === id) { matched = sections[i]; break; }
            }
            if (matched) {
              Array.prototype.forEach.call(tabs, function (t) {
                t.classList.toggle('tmv4-snav-desktop__tab--active', t.getAttribute('data-tmv4-tab') === matched.key);
              });
            }
          }
        });
      }, { rootMargin: '-50% 0px -50% 0px' });
      sections.forEach(function (s) { obs.observe(s.el); });
    })();

    /* 6. Vehicle-conditional Final CTA (headline / sub / cta) */
    (function () {
      var headlineEl = root.querySelector('[data-tmv4-final-headline]');
      var subEl = root.querySelector('[data-tmv4-final-sub]');
      var ctaEl = root.querySelector('[data-tmv4-final-cta]');
      var stickyAtcs = root.querySelectorAll('[data-tmv4-sticky-atc]');

      function applyFinal(v) {
        var saved = !!v;
        if (headlineEl) {
          var defH = headlineEl.getAttribute('data-tmv4-default-html') || '';
          var savH = headlineEl.getAttribute('data-tmv4-saved-template') || defH;
          headlineEl.innerHTML = saved ? savH.replace(/\{vehicle\}|&lcub;vehicle&rcub;/g, vehicleHtml(v)) : defH;
        }
        if (subEl) {
          var defS = subEl.getAttribute('data-tmv4-default-html') || '';
          var savS = subEl.getAttribute('data-tmv4-saved-template') || defS;
          subEl.innerHTML = saved ? savS.replace(/\{vehicle\}|&lcub;vehicle&rcub;/g, vehicleHtml(v)) : defS;
        }
        if (ctaEl) {
          var defL = ctaEl.getAttribute('data-tmv4-default-label') || '';
          var savL = ctaEl.getAttribute('data-tmv4-saved-label') || defL;
          ctaEl.textContent = saved ? savL : defL;
          ctaEl.setAttribute('data-tmv4-action', saved ? 'submit-main-form' : 'scroll-to-vehicle-fit');
        }
      }

      function applyStickyAtc(v) {
        var saved = !!v;
        Array.prototype.forEach.call(stickyAtcs, function (btn) {
          var defL = btn.getAttribute('data-tmv4-default-label') || '';
          var disL = btn.getAttribute('data-tmv4-disabled-label') || defL;
          var labelEl = btn.querySelector('[data-tmv4-sticky-atc-label]');
          if (saved) {
            btn.classList.remove('is-disabled');
            btn.disabled = false;
            if (labelEl) labelEl.textContent = defL;
            else btn.textContent = defL;
          } else {
            btn.classList.add('is-disabled');
            btn.disabled = true;
            if (labelEl) labelEl.textContent = disL;
            else btn.textContent = disL;
          }
        });
      }

      function syncAll() {
        var v = readVehicle();
        applyFinal(v);
        applyStickyAtc(v);
      }

      syncAll();
      document.addEventListener('matrikar:vehicleSelected', syncAll);
      window.addEventListener('storage', function (e) {
        if (e.key === 'matrikar_vehicle') syncAll();
      });
    })();

    /* 7. Click handlers : Sticky ATC + Final CTA + Find My Fit conditional */
    (function () {
      function submitMainForm() {
        var form = findMainForm();
        if (!form) return false;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
        return true;
      }
      function scrollToVehicleFit() {
        var node = document.querySelector('#mkvfit-wrap');
        if (!node) return;
        var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }

      root.addEventListener('click', function (e) {
        var stickyBtn = e.target.closest('[data-tmv4-sticky-atc]');
        if (stickyBtn) {
          if (stickyBtn.classList.contains('is-disabled') || stickyBtn.disabled) {
            scrollToVehicleFit();
            return;
          }
          if (!submitMainForm()) scrollToVehicleFit();
          return;
        }
        var finalBtn = e.target.closest('[data-tmv4-final-cta]');
        if (finalBtn) {
          var action = finalBtn.getAttribute('data-tmv4-action') || 'scroll-to-vehicle-fit';
          if (action === 'submit-main-form') {
            if (!submitMainForm()) scrollToVehicleFit();
          } else {
            scrollToVehicleFit();
          }
          return;
        }
        var fitBtn = e.target.closest('[data-tmv4-cta-fit]');
        if (fitBtn) {
          e.preventDefault();
          var v = readVehicle();
          if (v) {
            if (!submitMainForm()) scrollToVehicleFit();
          } else {
            scrollToVehicleFit();
          }
        }
      });
    })();

    /* 8. Sticky price sync (variant change) */
    (function () {
      var stickyPrices = root.querySelectorAll('[data-tmv4-sticky-price], [data-tmv4-sticky-mobile-price]');
      if (!stickyPrices.length) return;
      function getVariantIdFromForm() {
        var form = findMainForm();
        if (!form) return null;
        var input = form.querySelector('input[name="id"]');
        return input ? input.value : null;
      }
      function updatePrice() {
        var vid = getVariantIdFromForm();
        if (!vid) return;
        fetchVariants(function (vs) {
          if (!vs) return;
          var v = null;
          for (var i = 0; i < vs.length; i++) {
            if (String(vs[i].id) === String(vid)) { v = vs[i]; break; }
          }
          if (!v || typeof v.price !== 'number') return;
          var label = formatMoneyCents(v.price);
          Array.prototype.forEach.call(stickyPrices, function (n) { n.textContent = label; });
        });
      }
      function bind() {
        var form = findMainForm();
        if (form) {
          var sel = form.querySelector('select[name="id"]');
          if (sel) sel.addEventListener('change', function () { setTimeout(updatePrice, 80); });
        }
        var radios = document.querySelectorAll('input[type="radio"][data-option-position]');
        Array.prototype.forEach.call(radios, function (r) {
          r.addEventListener('change', function () { setTimeout(updatePrice, 120); });
        });
        document.addEventListener('variant:change', function () { setTimeout(updatePrice, 80); });
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bind);
      } else {
        bind();
      }
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-trunk-organizer-v4-content"] && !Shopify.designMode) return;
  try {
    
  /* Matrikar Trunk Organizer V4 — vanilla JS IIFE (no Liquid) */
  (function () {
    var root = document.querySelector('[data-tov4-section]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id') || '';
    var productId = root.getAttribute('data-product-id') || '';

    /* Locate the combo-builder snippet in the HAUT (intouchable) */
    function findComboBuilder() {
      if (productId) {
        var byProduct = document.querySelector('.mk-combo-builder[data-product-id="' + productId + '"]');
        if (byProduct) return byProduct;
      }
      return document.querySelector('.mk-combo-builder');
    }
    function scrollToCombo() {
      var combo = findComboBuilder();
      if (!combo) return false;
      var y = combo.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: y, behavior: 'smooth' });
      return true;
    }

    /* 1. Sticky nav trigger (2s OR scrollY > 400) */
    (function () {
      var snavTop = root.querySelector('[data-tov4-snav-desktop]');
      var snavBot = root.querySelector('[data-tov4-snav-mobile]');
      var shown = false;
      function show() {
        if (shown) return;
        shown = true;
        if (snavTop) snavTop.classList.add('is-visible');
        if (snavBot) snavBot.classList.add('is-visible');
      }
      setTimeout(show, 2000);
      function onScroll() {
        if (window.scrollY > 400) {
          show();
          window.removeEventListener('scroll', onScroll);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    })();

    /* 2. Sticky desktop tabs + scroll-spy */
    (function () {
      if (!sectionId) return;
      var snavTop = root.querySelector('[data-tov4-snav-desktop]');
      if (!snavTop) return;
      var tabs = snavTop.querySelectorAll('[data-tov4-tab]');
      var targetMap = {
        overview: 'tov4-overview-' + sectionId,
        sizes: 'tov4-sizes-' + sectionId,
        organization: 'tov4-organization-' + sectionId,
        compare: 'tov4-compare-' + sectionId,
        reviews: 'tov4-reviews-' + sectionId,
        faq: 'tov4-faq-' + sectionId
      };
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          var t = document.getElementById(targetMap[tab.getAttribute('data-tov4-tab')]);
          if (!t) return;
          var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });
      if (!('IntersectionObserver' in window)) return;
      var sections = Object.keys(targetMap)
        .map(function (k) { return { key: k, el: document.getElementById(targetMap[k]) }; })
        .filter(function (s) { return !!s.el; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            var matched = null;
            for (var i = 0; i < sections.length; i++) {
              if (sections[i].el.id === id) { matched = sections[i]; break; }
            }
            if (matched) {
              Array.prototype.forEach.call(tabs, function (t) {
                t.classList.toggle('tov4-snav-desktop__tab--active', t.getAttribute('data-tov4-tab') === matched.key);
              });
            }
          }
        });
      }, { rootMargin: '-50% 0px -50% 0px' });
      sections.forEach(function (s) { obs.observe(s.el); });
    })();

    /* 3. Sticky ATC + Final CTA -> scroll to combo-builder HAUT */
    root.addEventListener('click', function (e) {
      var stickyBtn = e.target.closest('[data-tov4-sticky-atc]');
      if (stickyBtn) {
        e.preventDefault();
        scrollToCombo();
      }
    });

    /* 4. Size cards S3 -> increment combo-builder stepper + scroll up
          Le combo-builder est intouche. On simule un click sur son bouton
          .mk-qty-plus pour la row dont le .mk-combo-size match le tag.
    */
    (function () {
      var sizeCards = root.querySelectorAll('[data-tov4-size-add]');
      if (!sizeCards.length) return;

      function findComboRow(sizeName) {
        var combo = findComboBuilder();
        if (!combo || !sizeName) return null;
        var rows = combo.querySelectorAll('.mk-combo-row');
        var target = sizeName.toLowerCase().trim();
        for (var i = 0; i < rows.length; i++) {
          var label = rows[i].querySelector('.mk-combo-size');
          if (label && label.textContent.toLowerCase().trim() === target) {
            return rows[i];
          }
        }
        return null;
      }

      Array.prototype.forEach.call(sizeCards, function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var sizeName = btn.getAttribute('data-tov4-size-add') || '';
          var row = findComboRow(sizeName);
          if (row) {
            var plusBtn = row.querySelector('.mk-qty-plus');
            if (plusBtn) plusBtn.click();
          }
          scrollToCombo();
        });
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkv4-anchor-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.mkv4-anchor');
    if (!root) return;
    var variantsScript = root.querySelector('[data-mkv4-anchor-variants]');
    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent) || []; } catch (e) { variants = []; }
    }
    var defaultVariant = variants[0] || null;

    function pickVariant(make) {
      if (!make) return defaultVariant;
      var lower = String(make).toLowerCase();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v || !v.make_keywords) continue;
        var kws = String(v.make_keywords).split(',');
        for (var j = 0; j < kws.length; j++) {
          var kw = kws[j].trim();
          if (kw && lower.indexOf(kw) !== -1) return v;
        }
      }
      return defaultVariant;
    }

    function readVehicle() {
      try {
        var raw = localStorage.getItem('matrikar_vehicle');
        if (!raw) return null;
        var v = JSON.parse(raw);
        if (v && v.make && v.year && v.model) return v;
        return null;
      } catch (e) {
        return null;
      }
    }

    var quoteEl = root.querySelector('[data-mkv4-anchor-quote]');
    var nameEl = root.querySelector('[data-mkv4-anchor-name]');
    var initialsEl = root.querySelector('[data-mkv4-anchor-initials]');
    var vehicleEl = root.querySelector('[data-mkv4-anchor-vehicle]');
    var imageEl = root.querySelector('[data-mkv4-anchor-image]');

    function apply(v) {
      if (!v) return;
      if (quoteEl) quoteEl.innerHTML = v.quote || '';
      if (nameEl) nameEl.textContent = v.author_name || '';
      if (initialsEl) initialsEl.textContent = v.author_initials || '';
      if (vehicleEl) vehicleEl.textContent = v.author_vehicle || '';
      if (imageEl && v.image_url) {
        imageEl.style.backgroundImage = "url('" + v.image_url + "')";
      }
    }

    function syncAll() {
      var vehicle = readVehicle();
      var matched = pickVariant(vehicle && vehicle.make);
      apply(matched || defaultVariant);
    }
    syncAll();
    document.addEventListener('matrikar:vehicleSelected', syncAll);
    window.addEventListener('storage', function (e) {
      if (e.key === 'matrikar_vehicle') syncAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkv4-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.mkv4-comp [data-mkv4-scroll-to="vehicle-fit"]');
      if (!btn) return;
      var node = document.querySelector('#mkvfit-wrap');
      if (!node) return;
      e.preventDefault();
      var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkv4-engineering"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.mkv4-eng');
    if (!root) return;
    var counters = root.querySelectorAll('[data-mkv4-counter]');
    if (!counters.length || !('IntersectionObserver' in window)) return;
    function animate(el) {
      var target = parseFloat(el.getAttribute('data-mkv4-counter')) || 0;
      var suffix = el.getAttribute('data-mkv4-counter-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(now) {
        if (!start) start = now;
        var t = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        var raw = target * eased;
        var value;
        if (target >= 1000) value = Math.floor(raw).toLocaleString('en-US');
        else if (target % 1 !== 0) value = raw.toFixed(1);
        else value = Math.floor(raw).toString();
        el.textContent = value + suffix;
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animate(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { obs.observe(c); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkv4-explore-series"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.mkv4-expl [data-mkv4-scroll-to="vehicle-fit"]');
      if (!btn) return;
      var node = document.querySelector('#mkvfit-wrap');
      if (!node) return;
      e.preventDefault();
      var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkv4-final-cta-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.mkv4-final2');
    if (!root) return;
    var productId = root.getAttribute('data-mkv4-final2-product-id') || '';

    function readVehicle() {
      try {
        var raw = localStorage.getItem('matrikar_vehicle');
        if (!raw) return null;
        var v = JSON.parse(raw);
        if (v && v.make && v.year && v.model) return v;
        return null;
      } catch (e) { return null; }
    }
    function vehicleHtml(v) {
      if (!v) return '';
      var parts = [];
      if (v.year) parts.push(v.year);
      if (v.make) parts.push(v.make);
      if (v.model) parts.push(v.model);
      return '<strong>' + parts.join(' ') + '.</strong>';
    }
    function findMainForm() {
      if (productId) {
        var f = document.querySelector('form[id^="product-form-main-' + productId + '-"][action*="/cart/add"]');
        if (f) return f;
      }
      return document.querySelector('product-form form[action*="/cart/add"]')
          || document.querySelector('form[id^="product-form-main-"][action*="/cart/add"]');
    }

    var headlineEl = root.querySelector('[data-mkv4-final2-headline]');
    var subEl = root.querySelector('[data-mkv4-final2-sub]');
    var ctaEl = root.querySelector('[data-mkv4-final2-cta]');

    function sync() {
      var v = readVehicle();
      var saved = !!v;
      if (headlineEl) {
        var defH = headlineEl.getAttribute('data-mkv4-default-html') || '';
        var savH = headlineEl.getAttribute('data-mkv4-saved-template') || defH;
        headlineEl.innerHTML = saved ? savH.replace(/\{vehicle\}|&lcub;vehicle&rcub;/g, vehicleHtml(v)) : defH;
      }
      if (subEl) {
        var defS = subEl.getAttribute('data-mkv4-default-html') || '';
        var savS = subEl.getAttribute('data-mkv4-saved-template') || defS;
        subEl.innerHTML = saved ? savS.replace(/\{vehicle\}|&lcub;vehicle&rcub;/g, vehicleHtml(v)) : defS;
      }
      if (ctaEl) {
        var defL = ctaEl.getAttribute('data-mkv4-default-label') || '';
        var savL = ctaEl.getAttribute('data-mkv4-saved-label') || defL;
        ctaEl.textContent = saved ? savL : defL;
        ctaEl.setAttribute('data-mkv4-action', saved ? 'submit-main-form' : 'scroll-to-vehicle-fit');
      }
    }

    sync();
    document.addEventListener('matrikar:vehicleSelected', sync);
    window.addEventListener('storage', function (e) {
      if (e.key === 'matrikar_vehicle') sync();
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mkv4-final2-cta]');
      if (!btn) return;
      e.preventDefault();
      var action = btn.getAttribute('data-mkv4-action') || 'scroll-to-vehicle-fit';
      if (action === 'submit-main-form') {
        var form = findMainForm();
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
          return;
        }
      }
      var node = document.querySelector('#mkvfit-wrap');
      if (!node) return;
      var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkv4-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.mkv4-final');
    if (!root) return;
    var productId = root.getAttribute('data-mkv4-product-id') || '';

    function readVehicle() {
      try {
        var raw = localStorage.getItem('matrikar_vehicle');
        if (!raw) return null;
        var v = JSON.parse(raw);
        if (v && v.make && v.year && v.model) return v;
        return null;
      } catch (e) {
        return null;
      }
    }

    function vehicleHtml(v) {
      if (!v) return '';
      var parts = [];
      if (v.year) parts.push(v.year);
      if (v.make) parts.push(v.make);
      if (v.model) parts.push(v.model);
      return '<strong>' + parts.join(' ') + '.</strong>';
    }

    function findMainForm() {
      if (productId) {
        var f = document.querySelector('form[id^="product-form-main-' + productId + '-"][action*="/cart/add"]');
        if (f) return f;
      }
      return document.querySelector('product-form form[action*="/cart/add"]')
          || document.querySelector('form[id^="product-form-main-"][action*="/cart/add"]');
    }

    var headlineEl = root.querySelector('[data-mkv4-final-headline]');
    var subEl = root.querySelector('[data-mkv4-final-sub]');
    var ctaEl = root.querySelector('[data-mkv4-final-cta]');

    function sync() {
      var v = readVehicle();
      var saved = !!v;
      if (headlineEl) {
        var defH = headlineEl.getAttribute('data-mkv4-default-html') || '';
        var savH = headlineEl.getAttribute('data-mkv4-saved-template') || defH;
        headlineEl.innerHTML = saved ? savH.replace('{vehicle}', vehicleHtml(v)) : defH;
      }
      if (subEl) {
        var defS = subEl.getAttribute('data-mkv4-default-html') || '';
        var savS = subEl.getAttribute('data-mkv4-saved-template') || defS;
        subEl.innerHTML = saved ? savS.replace('{vehicle}', vehicleHtml(v)) : defS;
      }
      if (ctaEl) {
        var defL = ctaEl.getAttribute('data-mkv4-default-label') || '';
        var savL = ctaEl.getAttribute('data-mkv4-saved-label') || defL;
        ctaEl.textContent = saved ? savL : defL;
        ctaEl.setAttribute('data-mkv4-action', saved ? 'submit-main-form' : 'scroll-to-vehicle-fit');
      }
    }

    sync();
    document.addEventListener('matrikar:vehicleSelected', sync);
    window.addEventListener('storage', function (e) {
      if (e.key === 'matrikar_vehicle') sync();
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mkv4-final-cta]');
      if (!btn) return;
      var action = btn.getAttribute('data-mkv4-action') || 'scroll-to-vehicle-fit';
      if (action === 'submit-main-form') {
        var form = findMainForm();
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
          return;
        }
      }
      var node = document.querySelector('#mkvfit-wrap');
      if (!node) return;
      var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkv4-micro-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.mkv4-micro [data-mkv4-scroll-to="vehicle-fit"]');
      if (!btn) return;
      var node = document.querySelector('#mkvfit-wrap');
      if (!node) return;
      e.preventDefault();
      var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkv4-sticky-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var snavTop = document.querySelector('[data-mkv4-snav-desktop]');
    var snavBot = document.querySelector('[data-mkv4-snav-mobile]');
    if (!snavTop && !snavBot) return;

    var productId = (snavTop && snavTop.getAttribute('data-mkv4-product-id')) || (snavBot && snavBot.getAttribute('data-mkv4-product-id')) || '';
    var productHandle = snavTop && snavTop.getAttribute('data-mkv4-product-handle') || '';
    var currencyIso = snavTop && snavTop.getAttribute('data-currency-iso') || 'CAD';
    var variantCache = null;

    function readVehicle() {
      try {
        var raw = localStorage.getItem('matrikar_vehicle');
        if (!raw) return null;
        var v = JSON.parse(raw);
        if (v && v.make && v.year && v.model) return v;
        return null;
      } catch (e) {
        return null;
      }
    }

    function findMainForm() {
      if (productId) {
        var f = document.querySelector('form[id^="product-form-main-' + productId + '-"][action*="/cart/add"]');
        if (f) return f;
      }
      return document.querySelector('product-form form[action*="/cart/add"]')
          || document.querySelector('form[id^="product-form-main-"][action*="/cart/add"]');
    }

    function formatMoneyCents(cents) {
      var iso = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || currencyIso;
      if (window.Shopify && window.Shopify.formatMoney) {
        var fmt = window.Shopify.money_format || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function fetchVariants(cb) {
      if (variantCache) { cb(variantCache); return; }
      if (!productHandle) { cb(null); return; }
      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (d) { variantCache = d.variants || []; cb(variantCache); })
        .catch(function () { cb(null); });
    }

    /* 1. Trigger : 2s OR scrollY > 400 */
    (function () {
      var shown = false;
      function show() {
        if (shown) return;
        shown = true;
        if (snavTop) snavTop.classList.add('is-visible');
        if (snavBot) snavBot.classList.add('is-visible');
      }
      setTimeout(show, 2000);
      function onScroll() {
        if (window.scrollY > 400) {
          show();
          window.removeEventListener('scroll', onScroll);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    })();

    /* 2. Tabs click + scroll-spy */
    (function () {
      if (!snavTop) return;
      var tabs = snavTop.querySelectorAll('[data-mkv4-tab]');
      var targetMap = {
        overview: 'mkv4-overview',
        engineering: 'mkv4-engineering',
        compare: 'mkv4-compare',
        reviews: 'mkv4-reviews',
        faq: 'mkv4-faq'
      };
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          var t = document.getElementById(targetMap[tab.getAttribute('data-mkv4-tab')]);
          if (!t) return;
          var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      });
      if (!('IntersectionObserver' in window)) return;
      var sections = Object.keys(targetMap)
        .map(function (k) { return { key: k, el: document.getElementById(targetMap[k]) }; })
        .filter(function (s) { return !!s.el; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            var matched = null;
            for (var i = 0; i < sections.length; i++) {
              if (sections[i].el.id === id) { matched = sections[i]; break; }
            }
            if (matched) {
              Array.prototype.forEach.call(tabs, function (t) {
                t.classList.toggle('mkv4-snav-desktop__tab--active', t.getAttribute('data-mkv4-tab') === matched.key);
              });
            }
          }
        });
      }, { rootMargin: '-50% 0px -50% 0px' });
      sections.forEach(function (s) { obs.observe(s.el); });
    })();

    /* 3. Sticky ATC disabled state + click */
    (function () {
      function applyAtc(vehicle) {
        var saved = !!vehicle;
        var btns = document.querySelectorAll('[data-mkv4-sticky-atc]');
        Array.prototype.forEach.call(btns, function (btn) {
          var defL = btn.getAttribute('data-mkv4-default-label') || '';
          var disL = btn.getAttribute('data-mkv4-disabled-label') || defL;
          var labelEl = btn.querySelector('[data-mkv4-sticky-atc-label]');
          if (saved) {
            btn.classList.remove('is-disabled');
            btn.disabled = false;
            if (labelEl) labelEl.textContent = defL;
            else btn.textContent = defL;
          } else {
            btn.classList.add('is-disabled');
            btn.disabled = true;
            if (labelEl) labelEl.textContent = disL;
            else btn.textContent = disL;
          }
        });
      }
      function syncAtc() { applyAtc(readVehicle()); }
      syncAtc();
      document.addEventListener('matrikar:vehicleSelected', syncAtc);
      window.addEventListener('storage', function (e) {
        if (e.key === 'matrikar_vehicle') syncAtc();
      });

      function submitMainForm() {
        var form = findMainForm();
        if (!form) return false;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
        return true;
      }
      function scrollToVehicleFit() {
        var node = document.querySelector('#mkvfit-wrap');
        if (!node) return;
        var y = node.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mkv4-sticky-atc]');
        if (!btn) return;
        if (btn.classList.contains('is-disabled') || btn.disabled) {
          scrollToVehicleFit();
          return;
        }
        if (!submitMainForm()) scrollToVehicleFit();
      });
    })();

    /* 4. Sticky price sync */
    (function () {
      var stickyPrices = document.querySelectorAll('[data-mkv4-sticky-price], [data-mkv4-sticky-mobile-price]');
      if (!stickyPrices.length) return;

      function getVariantIdFromForm() {
        var form = findMainForm();
        if (!form) return null;
        var input = form.querySelector('input[name="id"]');
        return input ? input.value : null;
      }
      function updatePrice() {
        var vid = getVariantIdFromForm();
        if (!vid) return;
        fetchVariants(function (vs) {
          if (!vs) return;
          var v = null;
          for (var i = 0; i < vs.length; i++) {
            if (String(vs[i].id) === String(vid)) { v = vs[i]; break; }
          }
          if (!v || typeof v.price !== 'number') return;
          var label = formatMoneyCents(v.price);
          Array.prototype.forEach.call(stickyPrices, function (n) { n.textContent = label; });
        });
      }
      function bind() {
        var form = findMainForm();
        if (form) {
          var sel = form.querySelector('select[name="id"]');
          if (sel) sel.addEventListener('change', function () { setTimeout(updatePrice, 80); });
        }
        var radios = document.querySelectorAll('input[type="radio"][data-option-position], .variant-set-card input[type="radio"]');
        Array.prototype.forEach.call(radios, function (r) {
          r.addEventListener('change', function () { setTimeout(updatePrice, 120); });
        });
        document.addEventListener('variant:change', function () { setTimeout(updatePrice, 80); });
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bind);
      } else {
        bind();
      }
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkv4-trust-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.mkv4-trust');
    if (!root) return;
    var counters = root.querySelectorAll('[data-mkv4-counter]');
    if (!counters.length || !('IntersectionObserver' in window)) return;
    function animate(el) {
      var target = parseFloat(el.getAttribute('data-mkv4-counter')) || 0;
      var suffix = el.getAttribute('data-mkv4-counter-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(now) {
        if (!start) start = now;
        var t = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        var raw = target * eased;
        var value;
        if (target >= 1000) value = Math.floor(raw).toLocaleString('en-US');
        else if (target % 1 !== 0) value = raw.toFixed(1);
        else value = Math.floor(raw).toString();
        el.textContent = value + suffix;
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animate(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { obs.observe(c); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-before-after-v3"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sliders = document.querySelectorAll('.ba-v3__slider');
    sliders.forEach((slider) => {
      const id = slider.id.replace('ba-slider-', '');
      const range = document.getElementById('ba-range-' + id);
      const afterEl = document.getElementById('ba-after-' + id);
      const divider = document.getElementById('ba-divider-' + id);
      const handle = document.getElementById('ba-handle-' + id);
      if (!range || !afterEl || !divider || !handle) return;

      const setPosition = (value) => {
        const v = Math.max(0, Math.min(100, parseFloat(value)));
        afterEl.style.clipPath = 'inset(0 0 0 ' + v + '%)';
        divider.style.left = v + '%';
        handle.style.left = v + '%';
      };

      range.addEventListener('input', (e) => setPosition(e.target.value));

      // Teaser animation once on scroll into view
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (prefersReduced) {
            observer.unobserve(entry.target);
            return;
          }
          setTimeout(() => {
            range.value = 65;
            setPosition(65);
          }, 400);
          setTimeout(() => {
            range.value = 50;
            setPosition(50);
          }, 1400);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.5 });

      observer.observe(slider);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-final-cta-v3"] && !Shopify.designMode) return;
  try {
    
  /* Find My Fit (home final CTA) — comportement conditionnel base sur l'etat vehicule.
     Reutilise la VRAIE logique de detection des PDP V4 (custom-product-v4-content L2178-2188) :
       - cle localStorage : 'matrikar_vehicle'
       - vehicle "rempli" = JSON parsable avec make + year + model non-vides
     Ecoute aussi l'evenement custom 'matrikar:vehicleSelected' et le 'storage'
     event si l'utilisateur saisit son vehicule dans un autre onglet pendant
     la navigation. Smooth scroll avec offset header sticky. */
  (function () {
    function readVehicle() {
      try {
        var raw = localStorage.getItem('matrikar_vehicle');
        if (!raw) return null;
        var v = JSON.parse(raw);
        if (v && v.make && v.year && v.model) return v;
        return null;
      } catch (e) {
        return null;
      }
    }
    function scrollToId(id) {
      var dest = document.getElementById(id);
      if (!dest) return false;
      /* P-PROMO FIX : la barre d'annonce + le header sont position:fixed (hors-flux),
         donc le wrapper .shopify-section-group-header-group s'effondre à ~0 → l'ancienne
         mesure renvoyait ~16px et la cible se garait SOUS l'overlay fixe (trou / images
         coupées en haut de "The Collection"). On calcule la hauteur réelle du stack fixe
         via les CSS vars (fallback : mesure du wrapper si vars absentes). */
      var cs = getComputedStyle(document.documentElement);
      var barH = parseFloat(cs.getPropertyValue('--announcement-bar-height')) || 0;
      var headH = parseFloat(cs.getPropertyValue('--header-height')) || 0;
      var offset = barH + headH;
      if (offset <= 0) {
        var header = document.querySelector('.shopify-section-group-header-group, header.header, [class*="site-header"]');
        offset = header ? header.getBoundingClientRect().height : 80;
      }
      offset += 16;
      var y = dest.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      if (history.replaceState) {
        history.replaceState(null, '', '#' + id);
      }
      return true;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-find-my-fit]');
      if (!btn) return;
      e.preventDefault();
      var hasVehicle = readVehicle() !== null;
      var targetId = hasVehicle ? 'home-collection' : 'home-vehicle-selector';
      /* Si la cible saved n'existe pas (cas rare), fallback sur le selecteur vehicule. */
      if (!scrollToId(targetId) && targetId === 'home-collection') {
        scrollToId('home-vehicle-selector');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero-v3"] && !Shopify.designMode) return;
  try {
    
  /* Hero V3 — bloc rating cliquable scroll smooth vers section reviews home.
     Offset header sticky pour ne pas masquer le titre de section. */
  (function () {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-scroll-reviews]');
      if (!trigger) return;
      var dest = document.getElementById('home-reviews');
      if (!dest) return;
      e.preventDefault();
      var header = document.querySelector('.shopify-section-group-header-group, header.header, [class*="site-header"]');
      var offset = header ? header.getBoundingClientRect().height + 16 : 80;
      var y = dest.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      if (history.replaceState) {
        history.replaceState(null, '', '#home-reviews');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-promo-v3"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.getElementById('promo-v3-{{ section.id }}'.replace(/[^a-zA-Z0-9_-]/g, ''));
    if (!section) {
      var fallback = document.querySelector('.promo-v3[data-variant-id]');
      if (fallback) section = fallback;
    }
    if (!section) return;

    var variantId = section.dataset.variantId;
    var fallbackUrl = section.dataset.ctaFallbackUrl;
    var cta = section.querySelector('.promo-v3__cta');
    var imageLink = section.querySelector('.promo-v3__image-wrapper');

    function getSavedVehicle() {
      try {
        var raw = localStorage.getItem('matrikar_vehicle');
        if (!raw) return null;
        var v = JSON.parse(raw);
        if (!v || !v.make || !v.year || !v.model) return null;
        return v;
      } catch (e) { return null; }
    }

    function buildVehicleProperties(vehicle) {
      var props = {};
      props['Vehicle'] = [vehicle.year, vehicle.make, vehicle.model].join(' ');
      if (vehicle.make) props['Make'] = String(vehicle.make);
      if (vehicle.year) props['Year'] = String(vehicle.year);
      if (vehicle.model) props['Model'] = String(vehicle.model);
      if (vehicle.trim) props['Trim'] = String(vehicle.trim);
      if (vehicle.seats) props['Seats'] = String(vehicle.seats);
      if (vehicle.drive_side) props['Drive Side'] = String(vehicle.drive_side);
      if (vehicle.fuel_type) props['Fuel Type'] = String(vehicle.fuel_type);
      return props;
    }

    function openCartDrawer() {
      var events = ['cart:open', 'cart-drawer:open', 'cart:refresh', 'cart:updated'];
      events.forEach(function(name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });
      var toggleSelectors = [
        '[data-cart-drawer-toggle]',
        '[data-cart-toggle]',
        '#cart-icon-bubble',
        '.cart-drawer-toggle',
        '.header__icon--cart',
        '[data-action="open-cart-drawer"]'
      ];
      for (var i = 0; i < toggleSelectors.length; i++) {
        var el = document.querySelector(toggleSelectors[i]);
        if (el && typeof el.click === 'function') {
          el.click();
          return true;
        }
      }
      setTimeout(function() { window.location.href = '/cart'; }, 600);
      return false;
    }

    function addToCartDirect(triggerEl, vehicle) {
      if (!variantId) return;
      if (cta) {
        cta.classList.add('is-loading');
        cta.setAttribute('aria-busy', 'true');
      }
      var properties = buildVehicleProperties(vehicle);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: properties
          }]
        })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) {
            throw new Error(err.description || ('ATC failed: ' + response.status));
          });
        }
        return response.json();
      })
      .then(function() {
        openCartDrawer();
      })
      .catch(function(err) {
        console.warn('[Promo V3] Direct ATC failed, falling back to PDP nav:', err);
        window.location.href = fallbackUrl || '/products/diamond-series-custom-fit-car-mats-all-black';
      })
      .finally(function() {
        if (cta) {
          cta.classList.remove('is-loading');
          cta.removeAttribute('aria-busy');
        }
      });
    }

    function handlePromoClick(e) {
      var vehicle = getSavedVehicle();
      if (!vehicle) {
        return;
      }
      e.preventDefault();
      addToCartDirect(e.currentTarget, vehicle);
    }

    if (cta) cta.addEventListener('click', handlePromoClick);
    if (imageLink) imageLink.addEventListener('click', handlePromoClick);
  })();

  } catch(e) { console.error(e); }
})();
})();
